export default __webpack_public_path__ + "static/logo-1c230a761fac0c734aab49db5fb6581a.png";